/* eslint-disable @typescript-eslint/no-explicit-any */
import { CatalogParamsProps } from '../modules/catalog/types';
import { GroupsModelDTO, ModelsMarkDTO, SearchByVinDTO, TypeDTO } from '../types';
import { Api } from './Api';

const API_TOKEN = 'aff5c01ed20d7854b2c5092db870eea9';

export class CatalogApi {
  static async searchByVIN(vin: string) {
    return await Api.get<SearchByVinDTO>(`/catalog/api/catalogs/search?text=${vin}`);
  }

  static async getCatalogs() {
    return await Api.get<TypeDTO[]>('/catalog/api/catalogs?lang=ru', {
      headers: {
        accept: 'application/json',
        Authorization: API_TOKEN,
      },
    });
  }

  static async getModels(data: Partial<CatalogParamsProps>) {
    const { type, mark } = data;
    return await Api.get<ModelsMarkDTO>(
      `/catalog/api/catalogs/models?auto_type=${type}&mark=${mark}&lang=ru`,
      {
        headers: {
          accept: 'application/json',
          Authorization: API_TOKEN,
        },
      },
    );
  }

  static async getModification({ type, mark, model, page }: Partial<CatalogParamsProps>) {
    return await Api.get<TypeDTO[]>(
      `/catalog/api/catalogs/modifications?auto_type=${type}&mark=${mark}&model=${model}&page=${page}&lang=ru`,
      {
        headers: {
          accept: 'application/json',
          Authorization: API_TOKEN,
        },
      },
    );
  }

  static async getGroups({ type, mark, model, modification }: Partial<CatalogParamsProps>) {
    return await Api.get<GroupsModelDTO[]>(
      `/catalog/api/catalogs/groups?auto_type=${type}&mark=${mark}&model=${model}&modification=${modification || null}&lang=ru`,
      {
        headers: {
          accept: 'application/json',
          Authorization: API_TOKEN,
        },
      },
    );
  }

  static async getSubGroups({
    type,
    mark,
    model,
    modification,
    group,
  }: Partial<CatalogParamsProps>) {
    return await Api.get<TypeDTO[]>(
      `/catalog/api/catalogs/groups?auto_type=${type}&mark=${mark}&model=${model}&modification=${modification}&group=${group}&lang=ru`,
      {
        headers: {
          accept: 'application/json',
          Authorization: API_TOKEN,
        },
      },
    );
  }

  static async getParts({
    type,
    mark,
    model,
    modification,
    group,
    parentId,
  }: Partial<CatalogParamsProps>) {
    return await Api.get<TypeDTO[]>(
      `/catalog/api/catalogs/parts?auto_type=${type}&mark=${mark}&model=${model}&modification=${modification}&group=${group}&parentGroup=${parentId}&lang=ru`,
      {
        headers: {
          accept: 'application/json',
          Authorization: API_TOKEN,
        },
      },
    );
  }

  static async getScheme({
    type,
    mark,
    model,
    modification,
    group,
    parentId,
  }: Partial<CatalogParamsProps>) {
    return await Api.getImage(
      `/catalog/api/catalogs/scheme?auto_type=${type}&mark=${mark}&model=${model}&modification=${modification}&group=${group}&parentGroup=${parentId}&lang=ru`,
    );
  }
}
